export const buildMy5SCardsFilters = (email: string) => ({
  'filters[$and][0][$or][0][isAudit][$null]': 'true',
  'filters[$and][0][$or][1][isAudit][$eq]': 'false',
  'filters[$and][1][$or][0][Auditor][email][$eqi]': email,
  'filters[$and][1][$or][1][CoAuditor][email][$eqi]': email,
  'sort[0]': 'PlannedDate:asc',
});
